import React, { forwardRef } from "react"

import { Checkbox } from "@/components"

import { useStyles } from "@/components/MultiSelectItem/MultiSelectItem.styles"

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string
    selected?: boolean
}

export const MultiSelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, selected, className, ...restProps }, ref) => {
        const { classes } = useStyles({ selected })

        return (
            <div className={className} data-selected={selected} ref={ref} {...restProps}>
                <Checkbox checked={selected} className={classes.checkbox} label={label} readOnly />
            </div>
        )
    },
)
